const sideScroll = function (element, direction, speed, distance, step) {
  let scrollAmount = 0;
  const slideTimer = setInterval(() => {
    if (direction === 'left') {
      element.scrollLeft -= step;
    } else {
      element.scrollLeft += step;
    }
    scrollAmount += step;
    if (scrollAmount >= distance) {
      window.clearInterval(slideTimer);
    }
  }, speed);
};

export default {
  init({ container, forwardButton, backButton }) {
    forwardButton.onclick = function () {
      sideScroll(container, 'right', 6, 360, 10);
    };

    backButton.onclick = function () {
      sideScroll(container, 'left', 6, 360, 10);
    };
  },
};
